import { render, staticRenderFns } from "./PropertyClientAddClientDialog.vue?vue&type=template&id=60f172f9"
import script from "./PropertyClientAddClientDialog.vue?vue&type=script&lang=ts"
export * from "./PropertyClientAddClientDialog.vue?vue&type=script&lang=ts"
import style0 from "./PropertyClientAddClientDialog.vue?vue&type=style&index=0&id=60f172f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports